import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { useSnackbar } from 'notistack';
import { useIntl } from 'react-intl';
import { getCroppedImage } from 'libs/common/utils';
import { uploadFile } from 'libs/common/utils/uploadFile';

var useSaveImageFromCrop = function useSaveImageFromCrop() {
  var intl = useIntl();

  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var saveImageFromCrop = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(image, crop) {
      var ratioX, ratioY, newCroppedImage, fileName, _yield$uploadFile, cdnFileUrl;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ratioX = image.naturalWidth / image.width;
              ratioY = image.naturalHeight / image.height;
              _context.next = 4;
              return getCroppedImage(image, {
                width: Math.round(crop.width * ratioX),
                height: Math.round(crop.height * ratioY),
                x: Math.round(crop.x * ratioX),
                y: Math.round(crop.y * ratioY)
              });

            case 4:
              newCroppedImage = _context.sent;
              fileName = "".concat(Date.now(), ".jpeg");

              if (!(newCroppedImage != null)) {
                _context.next = 20;
                break;
              }

              _context.prev = 7;
              _context.next = 10;
              return uploadFile(new File([newCroppedImage], fileName, {
                type: newCroppedImage.type
              }));

            case 10:
              _yield$uploadFile = _context.sent;
              cdnFileUrl = _yield$uploadFile.cdnFileUrl;
              enqueueSnackbar(intl.formatMessage({
                id: 'image-upload.success'
              }), {
                variant: 'success'
              });
              return _context.abrupt("return", cdnFileUrl);

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](7);
              enqueueSnackbar(intl.formatMessage({
                id: 'image-upload.error'
              }), {
                variant: 'error'
              });
              return _context.abrupt("return", null);

            case 20:
              enqueueSnackbar(intl.formatMessage({
                id: 'image-upload.error'
              }), {
                variant: 'error'
              });
              return _context.abrupt("return", null);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 16]]);
    }));

    return function saveImageFromCrop(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    saveImageFromCrop: saveImageFromCrop
  };
};

export default useSaveImageFromCrop;